import {types} from './types';

const setGetListTournamentAction = (payload) => {
    return {
        type: types.SET_LIST,
        payload,
      }
}

const setGetViewTournamentAction = (payload) => {
  return {
      type: types.SET_VIEW,
      payload,
    }
}

const setGetListTournamentStatAction = (payload) => {
  return {
    type: types.SET_LIST_STAT,
    payload,
  }
}

const setGetSearchGameAction = (payload) => {
  return {
    type: types.SET_SEARCH_GAME,
    payload
  }
}

export {
  setGetListTournamentAction,
  setGetViewTournamentAction,
  setGetListTournamentStatAction,
  setGetSearchGameAction
}